import React from 'react';
import Routes from "./routes";

const SignInFlow = () => React.createElement(Routes, null);

export default SignInFlow;